import React, { useEffect } from 'react'
import Text from '../Text'
import DocumentView from './DocumentView'
import Button from '../ButtonNew'
import { useDispatch, useSelector } from 'react-redux'
import * as actions from '../../store/slices'
import {
  supportProgramStatus,
  supportProgramTypes,
} from '../../constants/support-programs'
import Spinner from '../Spinner'

const UploadDocuments = ({ data, handleProceedClick }) => {
  const { ftuDocumentsWithoutVisit: documents } = useSelector(
    (state) => state.records,
  )
  const { patientDetails } = useSelector((state) => state.auth)
  const dispatch = useDispatch()
  const supportProgram = supportProgramTypes['liver-forever-program']

  console.log('documents', documents)

  useEffect(() => {
    fetchDocuments()
  }, [])

  const fetchDocuments = () => {
    const payload = {
      patient_id: patientDetails?.data?.patient_id,
      report_type: data?.upload_report_type,
    }
    new Promise((resolve, reject) => {
      dispatch(
        actions.fetchLiverFTUDocumentsWithoutVisitRequest({
          payload,
          resolve,
          reject,
        }),
      )
    })
  }

  return (
    <div className="relative flex flex-col h-full">
      <div className="flex-1 overflow-y-auto">
        <div className="p-4">
          <Text variant="title" size="large" tag="p" className="text-[#1F2933]">
            {data?.title}
          </Text>
          <Text variant="body" size="medium" tag="p" className="text-[#5A6774]">
            {data?.description}
          </Text>
        </div>

        {documents?.loading ? (
          <div className="flex justify-center items-center h-full">
            <Spinner />
          </div>
        ) : (
          <div className="px-4 flex flex-col gap-4 pb-4">
            {data?.document_types.map((documentTypes) => {
              const document =
                documents?.data?.data?.find(
                  (i) => i.title === documentTypes.document_title,
                ) ?? null

              const documentStatus =
                document?.record_meta_info?.report_status ===
                supportProgramStatus.DOCUMENT_REVIEW_STATUS.REJECTED
                  ? 'rejected'
                  : document?.record_meta_info?.report_status ===
                      supportProgramStatus.DOCUMENT_REVIEW_STATUS.UNDER_REVIEW
                    ? 'under_review'
                    : 'pending'

              return (
                <DocumentView
                  document={document}
                  documentType={documentTypes.document_type}
                  drugName={supportProgram?.drug_name}
                  uploadReportType={data?.upload_report_type}
                  documentStatus={documentStatus}
                  onUploadSuccess={() => fetchDocuments()}
                  // afterCompletion={() => onUploadSuccess('prescription')}
                  // setIsLoaderVisible={setLoader}
                  // onDeletePress={() => onDeletePress('prescription')}
                />
              )
            })}
          </div>
        )}
      </div>

      <div className="p-4 bg-white border-t border-gray-200">
        <Button
          fullWidth
          onClick={handleProceedClick}
          disabled={
            documents?.data?.data?.length !== data?.document_types.length
          }
          // disabled={supportProgram.document_types.some(
          //   (documentType) => documentType.document_status === 'pending',
          // )}
        >
          Proceed
        </Button>
      </div>
    </div>
  )
}

export default UploadDocuments
